import { Box, Typography } from "@mui/material";

const ResultsBox = ({ game }) => (
  <Typography
    variant="caption"
    sx={{
      color:
        game?.gameResult >= 2
          ? "success.main"
          : game?.gameResult === 1
          ? "info.main"
          : "error.main",
    }}
  >
    {game?.gamePoints || ""}
  </Typography>
);

const PlayerBox = ({
  roundNo,
  round,
  pairing,
  playerNo,
  sx,
  pairings,
  hoverPlayer,
  setHoverPlayer,
  startRoundNumber = 1,
}) => {
  try {
    var linkedPairingDetails = pairing?.[playerNo]?.linkedPairing;
    if (linkedPairingDetails) {
      var linkedPairingLink = `${linkedPairingDetails.podNum}.${linkedPairingDetails.roundNo}.${linkedPairingDetails.bracketPairingNum}`;

      var linkedPairing = linkedPairingDetails
        ? pairings?.[linkedPairingLink]
        : null;
      var linkedPlayer = !linkedPairing?.isDone
        ? undefined
        : linkedPairing?.player1Game?.gameResult ===
          (linkedPairingDetails?.winner
            ? 2
            : linkedPairingDetails?.loser
            ? 0
            : -1)
        ? linkedPairing?.player1
        : linkedPairing?.player2Game?.gameResult ===
          (linkedPairingDetails?.winner
            ? 2
            : linkedPairingDetails?.loser
            ? 0
            : -1)
        ? linkedPairing?.player2
        : undefined;
    }

    var player = linkedPlayer || pairing?.[playerNo];
  } catch (err) {
    console.error(roundNo + "\n" + err.stack);
  }

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor:
          player?.id && player?.id === hoverPlayer?.id
            ? "background.tertiary"
            : null,
        "&:hover": player?.id
          ? {
              cursor: "pointer",
            }
          : null,
        ...sx,
      }}
      onMouseOver={() => {
        setHoverPlayer(player);
      }}
      onMouseLeave={() => {
        setHoverPlayer(null);
      }}
    >
      <Box
        sx={{
          pl: 1,
          minHeight: "25px",

          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "80%",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontStyle:
              round?.conditional && pairing?.placeHolder ? "italic" : null,
          }}
        >
          {
            // eslint-disable-next-line
            roundNo == startRoundNumber
              ? `#${player?.bracket_seed || "--"} `
              : ""
          }
          {pairing?.placeHolder ||
          player?.firstName ||
          player?.user?.firstName ||
          player?.lastName ||
          player?.user?.lastName
            ? `${player?.firstName || player?.user?.firstName || ""} ${
                player?.lastName || player?.user?.lastName || ""
              }`
            : "------"}
        </Typography>
      </Box>
      <Box
        sx={{
          ml: "10px",
          width: "15%",
          textAlign: "center",
        }}
      >
        <ResultsBox game={pairing?.[`${[playerNo]}Game`]} />
      </Box>
    </Box>
  );
};

export default PlayerBox;
